<template>
  <div class="device-trace">
    <!-- 返回按钮 -->
    <div class="page-header">
      <el-button
          type="text"
          icon="el-icon-back"
          @click="goBack"
          size="medium"
      >
        返回首页
      </el-button>
    </div>

    <div class="trace-container">
      <h2 class="page-title">猜谜</h2>

      <!-- 快速搜索区：输入框 + 搜索按钮（已加大） -->
      <div class="search-section">
        <div class="search-input-wrapper">
          <el-input
              v-model="keyword"
              placeholder="请输入谜面关键词进行模糊搜索..."
              clearable
              size="large"
              @keyup.enter.native="handleSearch"
              class="search-input"
          >
            <el-button
                slot="append"
                icon="el-icon-search"
                @click="handleSearch"
                :loading="searching"
                size="large"
                class="search-btn"
            >搜索</el-button>
          </el-input>
        </div>
        <div class="search-tip" v-if="keyword && !searching && resultList.length === 0">
          <i class="el-icon-info"></i> 未找到相关谜语，试试其他关键词吧
        </div>
      </div>

      <!-- 结果表格：固定高度，内容可滚动，仅两列（题目、答案） -->
      <div class="result-table-wrapper" v-loading="searching">
        <el-table
            :data="resultList"
            stripe
            height="400"
            style="width: 100%"
            :header-cell-style="{ background: '#f5f7fa', color: '#303133', fontWeight: 'bold' }"
        >
          <el-table-column
              prop="title"
              label="谜面（题目）"
              min-width="200"
              show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="question-text">{{ scope.row.mk }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="answer"
              label="谜底（答案）"
              min-width="180"
              show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="answer-text">{{  scope.row.mv }}</span>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="empty-placeholder">
              <i class="el-icon-search" style="font-size: 48px; color: #c0c4cc;"></i>
              <p>{{ keyword ? '暂无匹配的谜语' : '输入关键词后点击搜索或按回车' }}</p>
            </div>
          </template>
        </el-table>
      </div>


    </div>
  </div>
</template>

<script>
export default {
  name: "RiddleSearch",
  data() {
    return {
      keyword: '',
      searching: false,
      resultList: [],      // 存储后台返回的列表 [{ title, answer }]
    };
  },
  mounted() {
    // 页面加载时可不自动请求，保持空白状态
  },
  methods: {
    // 模糊搜索核心方法：调用后台接口
    handleSearch() {
      const trimKeyword = (this.keyword || '').trim();
      if (!trimKeyword) {
        this.$message.warning('请输入搜索关键词');
        return;
      }

      this.searching = true;
      // 调用后端模糊搜索接口
      this.$request.postHttp({
        url: "/basic/getcm",   // 请替换为实际的后端模糊搜索接口
        params: { key: trimKeyword },
        success: (res) => {
          this.resultList=  res.data || [];

          this.searching = false;
        },
        error: (err) => {
          console.error("模糊搜索失败:", err);
          this.$message.error('搜索失败，请稍后重试');
          this.resultList = [];
          this.searching = false;
        }
      });
    },
    goBack() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
.device-trace {
  padding: 20px;
  background: #f9fafc;
  min-height: 100vh;
}

.page-header {
  margin-bottom: 15px;
  text-align: left;
}

.page-title {
  font-size: 28px;
  text-align: center;
  margin-bottom: 24px;
  color: #303133;
  font-weight: 500;
  letter-spacing: 1px;
}

.trace-container {
  max-width: 1000px;
  margin: 0 auto;
}

/* 搜索区 - 按钮加大样式 */
.search-section {
  margin-bottom: 24px;
}

.search-input-wrapper {
  max-width: 700px;
  margin: 0 auto;
}

.search-input {
  width: 100%;
}

/* 加大搜索按钮的样式 */
.search-input >>> .el-input-group__append {
  padding: 0 20px;
}

.search-btn {
  min-width: 80px;
  font-size: 16px;
  letter-spacing: 2px;
}

/* 或者直接通过全局样式加大按钮 */
.search-input >>> .el-button--large {
  height: 48px;
  line-height: 48px;
  font-size: 16px;
}

/* 同时让输入框也更高，与按钮协调 */
.search-input >>> .el-input__inner {
  height: 48px;
  line-height: 48px;
  font-size: 15px;
}

.search-tip {
  text-align: center;
  font-size: 14px;
  color: #909399;
  margin-top: 12px;
}

/* 固定高度表格容器 */
.result-table-wrapper {
  margin-top: 8px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  background: #fff;
}

.el-table {
  border-radius: 8px;
}

.question-text {
  font-weight: 500;
  color: #2c3e50;
}

.answer-text {
  color: #409eff;
  font-weight: 500;
}

.empty-placeholder {
  text-align: center;
  padding: 40px 0;
  color: #909399;
}

.empty-placeholder p {
  margin-top: 12px;
  font-size: 14px;
}

.quick-hint {
  margin-top: 24px;
}

/* 手机端适配 */
@media (max-width: 768px) {
  .device-trace {
    padding: 12px;
  }
  .page-title {
    font-size: 24px;
  }
  .search-input >>> .el-button--large {
    height: 44px;
    line-height: 44px;
    min-width: 70px;
  }
  .search-input >>> .el-input__inner {
    height: 44px;
    line-height: 44px;
  }
  .result-table-wrapper ::v-deep .el-table__body-wrapper {
    overflow-x: auto;
  }
}
</style>